module.exports = __webpack_public_path__ + "img/demand-area.1cd2fcf.png";